import React from "react";

import { Field, getIn } from "formik";

import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";

import { CustomDatepicker } from "../CustomDatepicker";

export const CustomDatepickerWField = ({
  fieldName,
  label,
  placeholder,
  isDisabled,
  mt,
  maxDate,
  blockDate,
  widthInput,
  inlineGrid,
  clear,
  setIsFocused,
  whiteSpace,
  onBeforeChange,
}) => {
  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          name={fieldName}
          isInvalid={
            getIn(form.errors, fieldName) && getIn(form.touched, fieldName)
          }
          id={fieldName}
          mt={mt ? mt : "0px"}
          display={
            inlineGrid
              ? "inline-grid"
              : blockDate && fieldName === "dataMovimentacao"
              ? "inline-grid"
              : ""
          }
        >
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            whiteSpace={whiteSpace ? "normal" : "nowrap"}
            htmlFor={fieldName}
          >
            {label}
          </FormLabel>
          <CustomDatepicker
            value={field.value}
            setValue={async (date) => {
              if (onBeforeChange) {
                const shouldProceed = await onBeforeChange(date, field.value);
                if (!shouldProceed) return;
              }
              form.setFieldValue(fieldName, date);
            }}
            placeholder={placeholder}
            isDisabled={!!isDisabled}
            maxDate={maxDate}
            widthInput={widthInput}
            clear={clear}
            setIsFocused={setIsFocused && setIsFocused}
          />
          <FormErrorMessage>{getIn(form.errors, fieldName)}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
